import { LI, UL } from "../../../../AbstractElements";
import { LayoutTypeProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";

const BoxLayout = ({ handleLayout, layout_type }: LayoutTypeProp) => {
  return (
    <LI className={`${layout_type === "box-layout" ? "active" : ""}`} data-attr="box" onClick={() => handleLayout("box-layout")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <UL className="simple-list d-flex flex-row">
          <LI className="bg-light sidebar"></LI>
          <LI className="bg-light body">
            <span className="badge badge-primary">Box</span>
          </LI>
        </UL>
      </div>
    </LI>
  );
};

export default BoxLayout;
